/**
 * @generated SignedSource<<cefd9d7eda6cf51d5ae9e156bd461e21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Client_getOrganization_Query$variables = {
  id: string;
};
export type Client_getOrganization_Query$data = {
  readonly organization: {
    readonly name: string;
  } | null;
};
export type Client_getOrganization_Query = {
  response: Client_getOrganization_Query$data;
  variables: Client_getOrganization_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Client_getOrganization_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Client_getOrganization_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4291817bb715e05685487e442198cc2a",
    "id": null,
    "metadata": {},
    "name": "Client_getOrganization_Query",
    "operationKind": "query",
    "text": "query Client_getOrganization_Query(\n  $id: ID!\n) {\n  organization(id: $id) {\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce4c957891115832d93e8afac934f750";

export default node;
